import {
  documentationUri,
  euCssStylesEnabled as isEUInstance,
  federalCssStylesEnabled as isFederalInstance,
} from '@gonfalon/constants/constants';

// path is after the baseUrl
// path example: 'home/getting-started' NOT 'docs/home/getting-started'
// leading slash is optional '/home/getting-started'
export function getDocumentationUrl(path: string = ''): string {
  let baseUrl = documentationUri() || 'https://launchdarkly.com/docs';
  // Remove trailing slash, if any, to avoid double slashes when appending
  baseUrl = baseUrl.replace(/\/+$/, '');

  const basePathname = new URL(baseUrl).pathname.replace(/\/+$/, '').replace(/^\//, '');
  const normalizedPath = path.replace(/^\//, '');
  const strippedPath =
    basePathname && normalizedPath.startsWith(`${basePathname}/`)
      ? normalizedPath.slice(basePathname.length + 1)
      : normalizedPath;

  // Ensure baseUrl ends with / so new URL() properly handles path segments
  baseUrl = `${baseUrl}/`;

  const url = new URL(strippedPath, baseUrl);
  const docsView = getDocsView();
  if (docsView && !url.hash) {
    url.hash = docsView;
  }

  return url.toString().replace(/\/$/, '').replace(/\/#/, '#');
}

function getDocsView() {
  if (isFederalInstance()) {
    return 'federal-docs';
  }
  if (isEUInstance()) {
    return 'eu-docs';
  }
  return undefined;
}
